import { Typography } from '@mui/material';
import { DefaultCard, PageLayout } from 'components';
import DropLetter from 'components/layout/dropLetter/DropLetter';
import React from 'react';

function HistoryPage() {
  return (
    <PageLayout>
      <DefaultCard title="HISTORY">
        <div>
          <Typography variant="body2" lineHeight={1.8}>
            <DropLetter letter="H" />
            armony Hill came into existence through the vision of Brother Roy T.
            and Sister Susie Denman. For many years it had been the burden of
            Brother Denman’s heart to provide a center of activity for the
            spiritual growth and development of the youth of Primitive Baptists
            and their friends.
          </Typography>
          <br />
          <Typography variant="body2" lineHeight={1.8}>
            The ministry took the form of a one week singing school, its first
            session being July, 1954, with 36 students and 1 instructor.
            Enrollment doubled the two succeeding years and has increased
            steadily to this time. Harmony Hill’s operation began with one
            building, a kitchen-cafeteria-classroom (a ‘temporary’ structure
            which served for more than 20 years!) Many buildings have been added
            in subsequent years to care for the overflow that gathers in June
            each year on this campsite overlooking Eagle Mountain Lake.
          </Typography>
          <br />
          <Typography variant="body2" lineHeight={1.8}>
            Young people from several states travel to Harmony Hill to join in
            fellowship with kindred in Christ and to open their hearts and minds
            to the study of hymns that praise God. The manifest blessings of God
            upon the work begun 50 years ago by this dedicated couple are
            marvelously experienced by all who attend.
          </Typography>
        </div>
      </DefaultCard>
    </PageLayout>
  );
}

export default HistoryPage;
